import React from 'react'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import { followTag, unfollowTag } from 'actions/follow'
import Card from 'components/Card'
import Tags from 'components/Tags'
import WhenLoggedIn from 'components/WhenLoggedIn'
import WhenNotLoggedIn from 'components/WhenNotLoggedIn'

/**
 * Displays a card showing the tags of the current redux `post` and the
 * follow/following state of those tags as available from existing redux
 * `following/tags` information.
 *
 * This component expects that the initial redux state was prepared by an
 * ancestor component.
 */
const TagsCard = () => {
  const { tags } = useSelector(selectForTags)
  const {
    onFollowTag,
    onUnfollowTag,
  } = useAPI()
  if (!tags.length) {
    return null
  }
  return (
    <Card>
      <WhenLoggedIn>
        <Tags tags={tags} onFollow={onFollowTag} onUnfollow={onUnfollowTag} />
      </WhenLoggedIn>
      <WhenNotLoggedIn>
        <Tags tags={tags} />
      </WhenNotLoggedIn>
    </Card>
  )
}

const convertTags = (
  tags,
  { map, } = {}
) => {
  if (map) {
    return {
      loading: false,
      tags:
        (tags &&
          tags.map(tag => {
            let t = map[tag] || {}
            return {
              _id: tag,
              following: t.following,
              updating: t.updating,
              error: t.error
            }
          })) ||
        []
    }
  } else {
    if (tags) {
      return {
        loading: true,
        tags: tags.map(tag => ({ _id: tag }))
      }
    } else {
      return {
        loading: true,
        tags: []
      }
    }
  }
}

const selectForTags = (state) => {
  const {
    post: { value: post } = {},
    following: { tags } = {}
  } = state
  return post ? convertTags(post.tags, tags) : { loading: true, tags: [] }
}

const useAPI = () => {
  const dispatch = useDispatch()
  return {
    onFollowTag: bindActionCreators(followTag, dispatch),
    onUnfollowTag: bindActionCreators(unfollowTag, dispatch)
  }
}
export default TagsCard
